import { Injectable } from '@angular/core';

import { ContentfulService } from './contentful.service';

@Injectable({
  providedIn: 'root'
})
export class AirportSearchService {
  airports: {
    LocationCode: string;
    CityCode: string;
    City: string;
    StateProvince: string;
    Country: string;
    Description: string;
    cityId: number;
    ufi: number;
  }[] = [];

  constructor(private contentfulService: ContentfulService) {
    const query = { 'fields.name': 'Airport Menu#SANDBOX' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      this.airports = items[0]?.fields.jsonData;
    });
  }

  searchAirportByKey(keyWord: string): Airport[] {
    return this.airports
      .filter(
        (airport) =>
          airport.LocationCode.toUpperCase().includes(keyWord.toUpperCase()) ||
          airport.City.toUpperCase().includes(keyWord.toUpperCase()) ||
          airport.Description.toUpperCase().includes(keyWord.toUpperCase())
      )
      .map((airport: any) => {
        return { LocationCode: airport.LocationCode, Description: airport.Description, City: airport.LocationCode + ' ' + airport.Description };
      });
  }
}

export interface Airport {
  LocationCode: string;
  Description: string;
  City: string;
}
